/**
 * First we will load all of this project's JavaScript dependencies which
 * include Vue and Vue Resource. This gives a great starting point for
 * building robust, powerful web applications using Vue and Laravel.
 */

import { searchProducts } from "../api/products/products";

window.$ = window.jQuery = require( 'jquery' );
require( 'bootstrap-sass' );
//window._ = _ = require('lodash');
//require('./bootstrap');

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

/*const app = new Vue({
    el: '#app'
});*/

/**
 * Axios for the search
 */
import {_axios} from '../api/axios'

let searchResults = $( '.search-results' );
$(document).ready(
    () => {
        $( '.search-fixed-top' ).keyup( ( event ) => {
            searchResults.empty();
            let searchText = event.target.value;
            if ( searchText.length > 0 ) {
                searchProducts(searchText).then(
                    ( response ) => {
                        _.each( response.data, ( product ) => {
                            let productTemp = $.trim( $( ".product-template" ).html() );
                            let description = product.description.length > 150 ? product.description.substring( 0, 150 - 3 ) + "..." : product.description;

                            let pricing = '';

                            if ( product.children.length > 0 ) {
                                pricing = $( ".children" ).html();
                                let options = '<option value=\'0\'>Please select</option>';
                                _.forEach(product.children, (child)=> {
                                    options += '<option cost=\'' + child.price + '\' value=\'' + child.id + '\'>' + child.name + ' | £' + child.price + '</option>\n' ;
                                });
                                pricing = pricing.replace( /@options@/, options)
                            } else {
                                pricing = $( ".single" ).html();

                                pricing = pricing
                                    .replace( /@name@/ig, product.full_name )
                                    .replace( /@price@/ig, product.price );
                            }
                            let initID = (product.children.length > 0) ? product.children[0].id : product.id;

                            productTemp = productTemp
                                .replace( /@name@/ig, product.full_name )
                                .replace( /@description@/ig, description )
                                .replace( /@img@/ig, 'https://grotec.co.uk/storage/products/' + product.photo )
                                .replace( /@weeks@/ig, ( product.weeks === '' ) ? '' : product.weeks )
                                .replace( /@ec@/ig, ( product.ec === '' ? '' : product.ec ) )
                                .replace( /@url@/ig, '/shop/product/' + product.slug )
                                .replace( /@pricing@/ig, pricing )
                                .replace( /@productID@/ig, initID)
                                .replace( /@productCOST@/ig, product.price);

                            $( '.search-results' ).append( productTemp );
                        } );


                    },
                    ( error ) => {
                        console.log( error );
                    }
                );
            } else {
                searchResults.empty();
            }
        } );

        $('body')
            .on(
                'click',
                '.add-to-cart',
                function() {
                    let form = $(this).parent('form');
                    event.preventDefault();
                    _axios.post('/sales/' + Laravel.cartId + '/items',

                    {
                        product_id:  form.children('.selected-product').val(),
                        quantity: form.children('.quantity').val(),
                        order_type: 'App\\Grotec\\Models\\Sales\\Sales',
                        cost: form.children('.selected-product-cost').val(),
                        note: ''
                    })
                }
            )
            .on(
                'change',
                '.children',
                function() {
                    let form = $(this).parent('form');
                    form.children('.selected-product').val($(this).val());
                    form.children('.selected-product-cost').val($(this).children("option:selected").attr('cost'))
                }
            );

            $(window).scroll(function (  ) {
                $('.grotec-side-collapse').collapse('hide');
            })
    }
);

/**
 * Load legacy javascript
 */
require( 'jquery-ui' );
require( 'lightbox2' );
require( './old/grotec.js' );